import React from "react";
import { AlertTriangle, Truck, CalendarOff } from "lucide-react";

// Edit the messages here. The marquee will loop seamlessly.
// Add/remove items in this array as your weekly schedule changes.
const MESSAGES = [
    {
        icon: CalendarOff,
        text: "WE'RE CLOSED JUNE 5–6 — Pre-order now for Friday June 12 or Saturday June 13 delivery. Pay a 10% deposit, balance due Thursday June 11 · 10 PM.",
    },
    {
        icon: AlertTriangle,
        text: "FOOD ALLERGEN WARNING — Before you place your order, check the website for food allergens or call us. We are not responsible if you order food you are allergic to.",
    },
    {
        icon: Truck,
        text: "WE DELIVER FRIDAYS & SATURDAYS — Order by Thursday 10 PM for Friday delivery. Order by Friday 10 PM for Saturday delivery. Delivery window: 11 AM – 8 PM.",
    },
];

// Repeat the message block enough times to make the marquee feel continuous.
const REPEAT = 3;

export default function AnnouncementBar() {
    const block = (
        <div className="flex items-center gap-12 px-8 shrink-0">
            {MESSAGES.map(({ icon: Icon, text }, i) => (
                <div key={i} className="flex items-center gap-3 shrink-0">
                    <Icon
                        size={16}
                        className="text-gold flex-shrink-0"
                        strokeWidth={2.5}
                    />
                    <span className="text-sm sm:text-[15px] font-medium tracking-wide whitespace-nowrap">
                        {text}
                    </span>
                </div>
            ))}
        </div>
    );

    return (
        <div
            data-testid="announcement-bar"
            className="relative w-full bg-forest text-white overflow-hidden border-b border-white/10"
            role="region"
            aria-label="Site announcements"
        >
            <div
                data-testid="announcement-marquee"
                className="flex announcement-marquee py-2.5 sm:py-3 will-change-transform"
                style={{ width: "max-content" }}
            >
                {Array.from({ length: REPEAT }).map((_, i) => (
                    <React.Fragment key={i}>{block}</React.Fragment>
                ))}
            </div>
        </div>
    );
}
